import { render, staticRenderFns } from "./CopyIcon.vue?vue&type=template&id=d4980d9a&scoped=true&"
import script from "./CopyIcon.vue?vue&type=script&lang=js&"
export * from "./CopyIcon.vue?vue&type=script&lang=js&"
import style0 from "./CopyIcon.vue?vue&type=style&index=0&id=d4980d9a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4980d9a",
  null
  
)

export default component.exports